export function stopBubbling(event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
}
